import { PaperOffset } from "paperjs-offset";
import { go, mapL, rangeL, takeAll, head, map, each } from "fxjs/es";
import { removeInnerPath, unitedPaths } from "./path_fns.js";
import { optimizePath } from "./path_optimizer.js";
import { makePaperProject } from "./utils.js";
import paper from "paper";

export const getOffsetPathdataStr = (
  pathdata_str,
  offset_len,
  is_united = true,
  is_remove_inner = true,
  is_test = false
) => {
  const is_pathdata_array = pathdata_str instanceof Array;
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();
  makePaperProject(
    paper_scope,
    is_test && 800,
    is_test && 800,
    is_test && document.body
  );
  return go(
    is_pathdata_array ? pathdata_str : [pathdata_str],
    map((pathdata_str) => {
      const is_compound_pathdata = [...pathdata_str.matchAll(/z/g)].length > 1;
      let path = is_compound_pathdata
        ? new paper_scope.CompoundPath(pathdata_str, {
            insert: false,
          })
        : new paper_scope.Path(pathdata_str, {
            insert: false,
          });
      if (is_united) {
        if (path instanceof paper_scope.CompoundPath) {
          let united_path = null;
          go(
            path.children,
            each((sub_path) => {
              united_path = !united_path
                ? sub_path
                : united_path.unite(sub_path, { insert: false });
            })
          );
          paper_scope.project.activeLayer.addChild(united_path);
          path = united_path;
        }
      }
      !path.clockwise && path.reverse();
      const offset_options = {
        join: "round",
        insert: true,
      };
      let offset_path = PaperOffset.offset(path, offset_len, offset_options);
      is_test &&
        offset_path.set({
          fill: "transparent",
          strokeColor: "green",
          strokeWidth: 1,
        });
      if (is_remove_inner) {
        offset_path instanceof paper_scope.CompoundPath &&
          removeInnerPath(offset_path);
      }
      return offset_path.pathData;
    }),
    (arr) => {
      if (!is_test) {
        paper_scope.remove();
        paper_scope = null;
      }
      return is_pathdata_array ? arr : head(arr);
    }
  );
};

export const pathOffsets = async (
  paper_path,
  start_len,
  is_set_style = null,
  counts = 1,
  step = 0,
  is_viewbox_intersect = false
) => {
  const paper_scope = paper_path._project._scope;
  paper_scope.activate();
  
  if (!step) step = 0;
  const control_size = Math.round(
    ((paper_scope.view.size.width + paper_scope.view.size.height) / 2) * 0.01
  );
  const offset_options = {
    join: "round",
    limit: "2",
    insert: false,
  };
  let outline_offsets_arr = go(
    rangeL(counts),
    mapL((i) => {
      const offset_len = start_len + step * i;

      //offset이 반대로 되는 것 방지
      paper_path.reorient(true, true);
      let offset_path = unitedPaths(
        PaperOffset.offset(paper_path, offset_len, offset_options)
      );
      offset_path instanceof paper_scope.CompoundPath &&
        removeInnerPath(offset_path);
      optimizePath(offset_path, control_size, false);

      //viewbox path와 boolean operation을 해서 intersection 검증
      if (is_viewbox_intersect) {
        const rect = paper_scope.view.bounds;
        const path_viewbox = new paper_scope.Path({
          segments: [
            [rect.x, rect.y],
            [rect.x + rect.width, rect.y],
            [rect.x + rect.width, rect.y + rect.height],
            [rect.x, rect.y + rect.height],
          ],
          closed: true,
          insert: false,
        });
        const is_intersect_boundary = offset_path.intersects(path_viewbox);
        if (is_intersect_boundary) {
          offset_path.replaceWith(
            (offset_path = offset_path.intersect(path_viewbox))
          );
        }
      }

      offset_path.sendToBack();

      if (is_set_style) {
        const offset_path_styles = {
          fillColor: "white",
          strokeColor: "orange",
          selectedColor: "red",
          strokeWidth: 2,
          visible: false,
          selected: false,
        };
        offset_path.set(offset_path_styles);
      }
      offset_path.name = `offset_item`;
      
      return {
        name: offset_path.name,
        offset_len: offset_len,
        length: Math.round(offset_path.length),
        area: Math.round(offset_path.area),
        paper_obj: offset_path,
        path_data: offset_path.pathData,
      };
    }),
    takeAll
  );
  if (outline_offsets_arr.length === 1) {
    outline_offsets_arr = head(outline_offsets_arr);
  }
  return Promise.resolve(outline_offsets_arr);
};
